import { useQuery } from '@tanstack/react-query';
import { fetchOrganizationDetails } from 'src/features/organization-details/api/lib/organization-details';
import { organizationDetailsKeys } from 'src/features/organization-details/api/query-keys/organization-details';
import { OrganizationDetails } from 'src/features/organization-details/api/types/interfaces/organization-details';
import { ApiError } from 'src/types/interfaces/api-error';

export const useOrganizationDetails = () => {
  return useQuery<OrganizationDetails, ApiError>({
    queryKey: organizationDetailsKeys.list(),
    queryFn: fetchOrganizationDetails,
  });
};
